import { render, staticRenderFns } from "./HlRegistrationFlowLayout.vue?vue&type=template&id=2ed23c3e&scoped=true&"
import script from "./HlRegistrationFlowLayout.vue?vue&type=script&lang=ts&"
export * from "./HlRegistrationFlowLayout.vue?vue&type=script&lang=ts&"
import style0 from "./HlRegistrationFlowLayout.vue?vue&type=style&index=0&id=2ed23c3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed23c3e",
  null
  
)

export default component.exports